import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AppClientConfigurationService, DashboardContext, DashboardDialogService, DialogService } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { DashboardDialogRegistry } from '@sdbn/common';
import { TransportRepresentation } from '../../../common/model/transport.model';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-transport-details-dialog-action',
    templateUrl: './transport-details-dialog-action.component.html',
    styleUrls: ['./transport-details-dialog-action.component.scss'],
    standalone: false
})
export class TransportDetailsDialogActionComponent {

  @Input() disabled = false;

  @Input() transport: TransportRepresentation;

  @Input() asButton = false;

  @Input() dashboardContext: DashboardContext;

  private dashboardDialogRegistry = new DashboardDialogRegistry();

  @Output() onChange = new EventEmitter<void>();

  contextSubscription: Subscription;

  constructor(
    public translationService: TranslationService,
    private dialogService: DialogService,
    private configurationService: AppClientConfigurationService,
    private dashboardDialogService: DashboardDialogService
  ) { }

  clickButton() {

    const dashboardContext = this.dashboardContext == null ? new DashboardContext() : this.dashboardContext;
    dashboardContext.setContextValue('selected-transport', this.transport);
    this.dashboardDialogService.openTransportDetailsDialog(dashboardContext);

  }
}

